// src/main.js
import { createApp } from 'vue'
import App            from './App.vue'
import store          from './store'
import router         from './router'
import '@/assets/tailwind.css'

async function bootstrap() {
  // 1) rehydrate & verify token
  try {
    await store.dispatch('auth/init')
  } catch {
    // token invalid or user inactive → go to login
    router.replace({ name: 'Login' })
  }
  // 2) if we’re already authed and on Login, go straight to Dashboard
  const isAuth      = store.getters['auth/isAuthenticated']
  const currentName = router.currentRoute.value.name
  if (isAuth && currentName === 'Login') {
    const user = store.getters['auth/currentUser']
    const org = String(user?.organization ?? '').toLowerCase()
    const userId = Number(user?.id)
    if (org === 'directtide') {
      if ([28, 29, 30, 31].includes(userId)) {
        router.replace({ name: 'LeadsTable' })
      } else {
        router.replace({ name: 'Invoices' })
      }
    } else {
      router.replace({ name: 'Dashboard' })
    }
  }

  // 3) now mount the app
  createApp(App)
    .use(store)
    .use(router)
    .mount('#app')
}

bootstrap()
